import { GetHomePageMenuMeta, GetHomePageMenuPayload } from 'types/store/GetHomePageMenu';
import { createAsyncReducer } from 'utils/Redux';

import { getHomePageMenuActions } from '../actions';

export default createAsyncReducer<GetHomePageMenuMeta, GetHomePageMenuPayload>(getHomePageMenuActions);
